import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { BULLET_POINTS_CONVERTER_TOKEN, BulletPointsConverter } from './bullet-points.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        bulletPointsFeature: {
          module: () => import('./bullet-points.module').then((m) => m.BulletPointsModule),
          cmsComponents: ['bulletpoints'],
        },
      }
    }),
    {
      provide: BULLET_POINTS_CONVERTER_TOKEN,
      useExisting: BulletPointsConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        bulletpoints: BULLET_POINTS_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class BulletPointsFeatureModule {}
